import { render, staticRenderFns } from "./MallDetailPage.vue?vue&type=template&id=b1550b24&scoped=true"
import script from "./MallDetailPage.vue?vue&type=script&lang=js"
export * from "./MallDetailPage.vue?vue&type=script&lang=js"
import style0 from "./MallDetailPage.vue?vue&type=style&index=0&id=b1550b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1550b24",
  null
  
)

export default component.exports